import { useEffect, useLayoutEffect, useRef } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router'
import { useAnmeldung } from '../lib/anmeldung'
import { pfad, pfadIn, useArt, type Art } from '../lib/art'
import { Profilmenue } from './Profilmenue'

const beschriftung: Record<Art, string> = {
  kontoauszug: 'Kontoauszüge',
  kreditkarte: 'Kreditkarten',
}

/**
 * Die Reiterzeile benennt die Seite — deshalb tragen die Seiten selbst keine
 * Ueberschrift. Aktionen gehoeren nicht hierher: sie gehoeren zu der Liste,
 * auf die sie wirken.
 */
export function Kopfzeile() {
  const { auskunft } = useAnmeldung()
  const kopf = useRef<HTMLElement>(null)
  const art = useArt()
  const ort = useLocation()
  const navigiere = useNavigate()

  /* Die Hoehe der Kopfzeile haengt an der Schriftgroesse und bricht auf
     schmalen Fenstern um. Was darunter kleben soll, braucht sie als Mass. */
  // Der Fenstertitel sagt, auf welcher Seite man ist.
  useEffect(() => {
    document.title = beschriftung[art]
  }, [art])

  useLayoutEffect(() => {
    const kasten = kopf.current
    if (!kasten) return
    const messen = () => document.documentElement.style.setProperty('--kopf-hoehe', `${kasten.offsetHeight}px`)
    messen()
    const beobachter = new ResizeObserver(messen)
    beobachter.observe(kasten)
    return () => beobachter.disconnect()
  }, [auskunft])

  if (!auskunft) return null
  const verwaltung = auskunft.benutzer.rolle === 'verwaltung'
  const reiter = ({ isActive }: { isActive: boolean }) => (isActive ? 'aktiv' : '')
  // Beim Umschalten bleibt man, wo man ist: beim Mandanten zum selben Mandanten.
  const wechseln = (ziel: Art) => navigiere(pfadIn(ziel, ort.pathname))

  return (
    <header className="kopf" ref={kopf}>
      <div className="kopf-oben">
        <div className="wortmarke">
          H&amp;K <span>Automation</span>
        </div>
        {verwaltung ? (
          <div className="kopf-luecke" />
        ) : (
          <div className="umschalter" role="group" aria-label="Kontoauszüge oder Kreditkarten">
            {(['kontoauszug', 'kreditkarte'] as const).map((a) => (
              <button key={a} type="button" aria-pressed={a === art} onClick={() => wechseln(a)}>
                {beschriftung[a]}
              </button>
            ))}
          </div>
        )}
        <Profilmenue />
      </div>

      <div className="kopf-unten">
        <nav className="reiter">
          {verwaltung ? (
            <NavLink to="/verwaltung" className={reiter}>Kanzleien</NavLink>
          ) : (
            <>
              <NavLink to={pfad(art, '/eingang')} className={reiter}>Eingang</NavLink>
              <NavLink to={pfad(art, '/mandanten')} className={reiter}>Mandanten</NavLink>
              <NavLink to={pfad(art, '/exporte')} className={reiter}>Exporte</NavLink>
            </>
          )}
        </nav>
      </div>
    </header>
  )
}
